"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinDebitReasonCodes = exports.getPinDebitErrorMessage = exports.pinDebitErrors = exports.DEFAULT_PIN_DEBIT_ERROR = void 0;
// import { SOURCES } from './constants/sources';
var get_message_1 = require("./get-message");
var constants_1 = require("./constants");
exports.DEFAULT_PIN_DEBIT_ERROR = 'Unable to process electronic payment.';
// SOURCE: https://dutchie.atlassian.net/wiki/spaces/EN/pages/20071317581/Pin+Debit+Error+Reason+Codes
exports.pinDebitErrors = new Map([
    [
        'DC-00',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic payment. Register is not associated with a Debit terminal. Register configuration can be updated by an Admin in your backoffice.',
            pos: 'Unable to process electronic payment. Register is not associated with a Debit terminal. Register configuration can be updated by an Admin in your backoffice.',
        },
    ],
    [
        'DC-01',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic payment. Order has an electronic payment that is already being processed.',
            pos: 'Unable to process electronic payment. Order has an electronic payment that is already being processed.',
        },
    ],
    [
        'DC-02',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment failed. Cannot apply additional electronic payments to this order.',
            pos: 'Electronic payment failed. Cannot apply additional electronic payments to this order.',
        },
    ],
    [
        'DC-03',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic payment. Debit payment services are temporarily unavailable. Please try again.',
            pos: 'Unable to process electronic payment. Debit payment services are temporarily unavailable. Please try again.',
        },
    ],
    [
        'DC-04',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment failed. Background job failed. Please try again.',
            pos: 'Electronic payment failed. Background job failed. Please try again.',
        },
    ],
    [
        'DC-05',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment failed. Order has already been completed. Additional payments cannot be added to a completed order.',
            pos: 'Electronic payment failed. Order has already been completed. Additional payments cannot be added to a completed order.',
        },
    ],
    [
        'DC-06',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment failed. Background job failed. Please try again.',
            pos: 'Electronic payment failed. Background job failed. Please try again.',
        },
    ],
    [
        'DC-07',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment cancelled. Payment services are currently unavailable. Please try again.',
            pos: 'Electronic payment cancelled. Payment services are currently unavailable. Please try again.',
        },
    ],
    [
        'DC-08',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment error. Background job failed. Please try again.',
            pos: 'Electronic payment error. Background job failed. Please try again.',
        },
    ],
    [
        'DC-09',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Electronic payment error. Unhandled error while polling. Please try again.',
            pos: 'Electronic payment error. Unhandled error while polling. Please try again.',
        },
    ],
    [
        'DC-10',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic payment. Unrecognized response from electronic payment network. Please use a different method of payment.',
            pos: 'Unable to process electronic payment. Unrecognized response from electronic payment network. Please use a different method of payment.',
        },
    ],
    [
        'DC-11',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Integrated refunds are not available for Pin Debit transactions.',
            pos: 'Integrated refunds are not available for Pin Debit transactions.',
        },
    ],
    [
        'DC-12',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic refund. Integrated Reverse-refunds are not available for Pin Debit transactions. Please use the Pin Debit terminal directly.',
            pos: 'Unable to process electronic refund. Integrated Reverse-refunds are not available for Pin Debit transactions. Please use the Pin Debit terminal directly.',
        },
    ],
    [
        'DC-13',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic refund. Integrated voids are not available for Pin Debit transactions. Please use the Pin Debit terminal directly.',
            pos: 'Unable to process electronic refund. Integrated voids are not available for Pin Debit transactions. Please use the Pin Debit terminal directly.',
        },
    ],
    [
        'DC-14',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Failed to cancel transaction. No pending transaction was found.',
            pos: 'Failed to cancel transaction. No pending transaction was found.',
        },
    ],
    [
        'DC-15',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Failed to cancel transaction. Transaction has already completed.',
            pos: 'Failed to cancel transaction. Transaction has already completed.',
        },
    ],
    [
        'DC-16',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Failed to cancel transaction. Transaction has already failed.',
            pos: 'Failed to cancel transaction. Transaction has already failed.',
        },
    ],
    [
        'DC-17',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: '',
            pos: '',
        },
    ],
    [
        'DC-18',
        {
            source: constants_1.SOURCES.DATA_CAP,
            ecomm: 'Unable to process electronic payment. Please try again.',
            pos: 'Unable to process electronic payment. Please try again.',
        },
    ],
    [
        '003001',
        {
            source: constants_1.SOURCES.TRANCLOUD,
            ecomm: 'Electronic payment failed. Debit terminal is not connected. Check debit terminal connectivity and try again.',
            pos: 'Electronic payment failed. Debit terminal is not connected. Check debit terminal connectivity and try again.',
        },
    ],
    [
        '004003',
        {
            source: constants_1.SOURCES.PAYNETWORX,
            ecomm: 'Electronic payment failed. Payment method was declined. Please try an alternative payment method.',
            pos: 'Electronic payment failed. Payment method was declined. Please try an alternative payment method.',
        },
    ],
    [
        '003342',
        {
            source: constants_1.SOURCES.DC_DIRECT,
            ecomm: 'Electronic payment failed. Transaction was canceled. Please try again.',
            pos: 'Electronic payment failed. Transaction was canceled. Please try again.',
        },
    ],
    [
        '003010',
        {
            source: constants_1.SOURCES.DC_DIRECT,
            ecomm: 'Electronic payment failed. Transaction timed out. Please try again.',
            pos: 'Electronic payment failed. Transaction timed out. Please try again.',
        },
    ],
    [
        '004010',
        {
            source: constants_1.SOURCES.DC_DIRECT,
            ecomm: 'Electronic payment failed. Unrecognized Request Format. Please try again.',
            pos: 'Electronic payment failed. Unrecognized Request Format. Please try again.',
        },
    ],
]);
function getPinDebitErrorMessage(errCode, defaultMsg) {
    if (defaultMsg === void 0) { defaultMsg = exports.DEFAULT_PIN_DEBIT_ERROR; }
    return (0, get_message_1.getMessage)(exports.pinDebitErrors, defaultMsg, errCode);
}
exports.getPinDebitErrorMessage = getPinDebitErrorMessage;
exports.pinDebitReasonCodes = Array.from(exports.pinDebitErrors.keys());
